import React from 'react';
import './error-page.css'; // Import the accompanying CSS file

const ErrorBanner = ({ onRetry }) => {
  return (
    <div className="error-box">
      <h1>🚧 Server Unavailable</h1>
      <p>Oops! It looks like our servers are currently down or unreachable.</p>
      <p>Please try again in a few moments.</p>
      {onRetry && (
        <button onClick={onRetry} className="close-button">
          Close
        </button>
      )}
    </div>
  );
};
export default ErrorBanner;
